import { AppDefinition } from '../../types/apps';

export const NeurvanaAppDefinition: AppDefinition = {
  appId: 'neurvana',
  name: 'Neurvana',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Brain',
    phosphorWeight: 'duotone',
    color: '#8b5cf6',
    metadata: {
      source: 'app',
      appId: 'neurvana',
      isAppIcon: true
    }
  },
  description: 'Neuroimaging data management and organization',
  version: '0.1.0',
  events: {
    onScanComplete: 'neurvana.scanComplete',
    onFileTagged: 'neurvana.fileTagged',
    onDuplicateFound: 'neurvana.duplicateFound'
  },
  entityTypes: ['File', 'Note'],
  component: 'NeurvanaApp',
  requiresProps: false,
  requiresEntity: false,
  supportedFileTypes: ['.nii', '.nii.gz', '.dcm', '.mgh', '.mgz', '.mnc'],
  features: ['scanner', 'tagger', 'duplicateFinder', 'ruleEngine'],
  experimental: true,
}; 